import { ExcessRefundByIdRedux, ExcessRefundReducerDispatch, ExcessRefundReduxState, ExcessRefundTypes } from "./types";

const EXCESS_REFUND_LIST_INIT_STATE = {
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: {
        self: null,
        first: null,
        previous: null,
        next: null,
        last: null
      }
    },
    records: []
  },
  loading: false,
  error: null
};

const ExcessRefundListReducer = (state: ExcessRefundReduxState = EXCESS_REFUND_LIST_INIT_STATE, action: ExcessRefundReducerDispatch) => {
  switch (action.type) {
    case ExcessRefundTypes.FETCH_EXCESS_REFUND_REQUEST: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case ExcessRefundTypes.FETCH_EXCESS_REFUND_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case ExcessRefundTypes.FETCH_EXCESS_REFUND_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case ExcessRefundTypes.RESET: {
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    }
    default:
      return { ...state };
  }
};

const EXCESS_REFUND_INIT_STATE = {
  data: {},
  loading: false,
  error: null
};
const ExcessRefundReducer = (state: ExcessRefundByIdRedux = EXCESS_REFUND_INIT_STATE, action: ExcessRefundReducerDispatch) => {
  switch (action.type) {
    case ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_REQUEST: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_FAIL: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case ExcessRefundTypes.RESET: {
      return {
        ...state,
        data: {},
        loading: false,
        error: false
      };
    }
    default:
      return { ...state };
  }
};

export { ExcessRefundListReducer, ExcessRefundReducer };
